/* 公共引入,勿随意修改,修改时需经过确认 */

import Vue from 'vue'
import './element'
import '@/styles/index.scss'
import '@/permission' // permission control
import './api'
import './msg'
import './storage'
import BaseForm from '@/components/BaseForm/index'
import SvgIcon from '@/components/SvgIcon/index'
import { noEmpty } from '@/utils'

Vue.component('base-form', BaseForm)
Vue.component('svg-icon', SvgIcon)
Vue.prototype.noEmpty = noEmpty



// WEBPACK FOOTER //
// ./src/plugins/index.js